<template>
  <div v-if="!isLoading && data" class="layout-matrix">
    <v-container>
      <v-row no-gutters class="justify-end mb-4">
        <v-col cols="12">
          <div>
            <div>สาขา</div>
            <BranchDropdown
              :error="$v.branchCode.$error"
              :error-messages="errorMessageBranchCode"
              @change="onChangeBranch"
            />
          </div>
        </v-col>
        <v-col cols="12">
          <div>
            <div>รหัสพนักงาน</div>
            <v-text-field
              v-model="staffCode"
              :color="colorBnn['color-bnn']"
              background-color="white"
              class="input-staff text-sm mt-2"
              placeholder="รหัสพนักงาน"
              maxlength="10"
              oninput="this.value=this.value.replace(/[^\d]+/g, '')"
              :error="$v.staffCode.$error"
              :error-messages="errorMessageStaffCode"
              @keyup.enter="staffVerify"
              :disabled="isVerified"
            >
              <template v-slot:append>
                <v-icon v-if="isVerified" color="green">
                  mdi-check-bold
                </v-icon>
                <v-icon
                  v-if="errorMessageStaffCode"
                  color="red"
                  @click="clearErrorMessage"
                >
                  mdi-close
                </v-icon>
              </template>
            </v-text-field>
            <div class="wrap-btn-verify mb-3">
              <v-btn depressed v-if="isVerified" @click="clearVerify">
                แก้ไขรหัสพนักงาน
              </v-btn>

              <v-btn
                depressed
                v-else
                :color="colorBnn['color-bnn']"
                @click="staffVerify"
              >
                <span class="btn-verify-text">
                  ยืนยันรหัสพนักงาน
                </span>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <div class="model-stock-container">
        <ButtonModelStock
          v-for="(item, index) in modelItems"
          @click="onClickModel(item)"
          :select="item === selectModel"
          :title="item"
          :key="index"
        />
      </div>
      <div class="overflow">
        <table>
          <thead>
            <tr class="bg-fafafa">
              <th class="text-left">Product Name</th>
              <th>
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="m in productItems">
              <tr
                v-for="(item, index) in m.model"
                :key="`${m.name}${item.size}`"
                class="border-top"
              >
                <td>
                  <div>{{ m.name }} {{ item.size }}</div>
                  <div class="color-content">
                    <template v-for="color in item.data">
                      <ButtonColor
                        @click="onClickSelectColor(color, index)"
                        :select="selectColor === color"
                        :color="color.color_hex"
                        :key="color.color"
                        :isShowCancelIcon="!color.is_active"
                        width="36"
                        height="36"
                      />
                    </template>
                  </div>

                  <div
                    v-if="
                      indexShowDetail === index && selectColorIsActive
                    "
                    class="model-select-color"
                  >
                    {{
                      selectColorMessage ||
                        `${m.name} ${item.size} ${item.title}`
                    }}
                  </div>
                  <div
                    v-else-if="
                      indexShowDetail === index &&
                        !selectColorIsActive
                    "
                    class="model-select-color-not-active"
                  >
                    {{ `${selectColor.name || ''}  สินค้าหมด` }}
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-center w-full">
                    <span
                      v-if="
                        indexShowDetail === index &&
                          selectColorIsActive
                      "
                      @click.stop="openDialog()"
                      class="text-span-receive"
                      color="#459d43"
                    >
                      <v-chip
                        :color="isVerified ? '#459d43' : '#ccc'"
                        class="status"
                        dark
                      >
                        แสดง QR Code
                      </v-chip>
                      <div
                        v-if="!isVerified"
                        class="text-xs text-red mt-1"
                      >
                        กรุณายืนยันรหัสพนักงาน
                      </div>
                    </span>

                    <span
                      v-else-if="
                        indexShowDetail === index &&
                          !selectColorIsActive
                      "
                    >
                    </span>
                    <span v-else class="text-span-receive">
                      <v-chip color="warning" class="status" dark>
                        {{ item.title }}
                      </v-chip>
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </v-container>

    <v-dialog v-model="dialog" falsewidth="40px" max-width="350px">
      <v-card style="overflow:hidden">
        <v-card-title v-if="selectColor">
          <div class="w-full d-flex justify-center text-center">
            <h3 class="text-center">
              <div>
                {{ selectColor.name || '' }}
              </div>
            </h3>
          </div>
        </v-card-title>
        <div class="card-qrcode">
          <qrcode-vue :value="deepLink" size="300"></qrcode-vue>
        </div>
        <v-card-actions class="d-flex justify-center">
          <div class="action-layout">
            <v-btn
              @click.stop="dialog = false"
              block
              outlined
              class="btn-cancel"
              width="80px"
              height="4px"
            >
              <span class="text-cancel">
                ย้อนกลับ
              </span>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import router from '@/router'
import QrcodeVue from 'qrcode.vue'
import ButtonColor from './ButtonColor.vue'
import ButtonModelStock from './ButtonModelStock.vue'
import BranchDropdown from './BranchDropdown.vue'
import colorBnn from '@/config/color'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],

  validations: {
    staffCode: {
      required,
      maxLength: maxLength(10),
    },
    branchCode: {
      required,
    },
  },

  computed: {
    ...mapState({
      isLoading: state => state.stock.isLoading,
      isVerified: state => state.stock.isVerified,
      errorMessageResponse: state => state.stock.errorMessage,
      data: state => state.stock.dataV2,
    }),

    modelItems() {
      const name = this.data?.models?.map(item => item?.name)
      return name
    },

    selectColorMessage() {
      let message = ''
      if (
        !this.selectColor?.message &&
        !this.selectColor?.date?.message
      ) {
        return null
      }
      if (this.selectColor?.message) {
        message = this.selectColor?.message
      } else if (this.selectColor?.date?.message) {
        message = this.selectColor?.date?.message
      }

      return `${this.selectColor?.name} ${message}`
    },

    couponCodeParam() {
      return router.currentRoute.query.v
    },

    selectColorIsActive() {
      return this.selectColor?.is_active
    },

    errorMessageStaffCode() {
      if (this.$v.staffCode.$error) {
        return 'กรุณากรอกรหัสพนักงาน'
      } else if (this.errorMessageResponse) {
        return this.errorMessageResponse
      }
      return ''
    },

    errorMessageBranchCode() {
      if (this.$v.branchCode.$error) {
        return 'กรุณาเลือกสาขา'
      }
      return ''
    },

    campaignType() {
      return process.env.VUE_APP_CAMPAIGN_TYPE ?? 'BNN'
    },
  },

  components: {
    // Panel,
    QrcodeVue,
    ButtonColor,
    ButtonModelStock,
    BranchDropdown,
  },

  mounted() {
    this.$nextTick(() => {
      this.onClickModel(this?.modelItems?.[0])
    })
  },

  data() {
    return {
      colorBnn,
      timer: null,
      dialog: false,
      deepLink: '',
      currentSelect: null,
      branchId: this.$route.query.branch_id ?? null,
      branchCode:
        this.$route.query.branch_code ??
        sessionStorage.getItem('bc') ??
        null,
      selectColor: null,
      productItems: [],
      staffCode: sessionStorage.getItem('sc') ?? null,
      isShowVerifyBtn: false,
      indexShowDetail: null,
    }
  },

  methods: {
    async getData() {
      await this.$store.dispatch('stock/getStockLiveV2', {
        slug: this.$route.params.slug,
        refetch: true,
      })
    },

    async staffVerify() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.indexShowDetail = null

      await this.$store.dispatch('stock/staffVerify', {
        branch_code: this.branchCode,
        staff_code: this.staffCode,
      })
    },

    clearErrorMessage() {
      this.staffCode = null
      this.clearVerify()
    },

    clearVerify() {
      this.$store.dispatch('stock/resetVerify')
    },

    textHasStockOrShipment(val) {
      return val?.title || 'พร้อมส่ง'
    },

    async onClickSelectColor(color, index) {
      await this.getData()
      this.$emit('onClickSelectColor')

      // waiting 30 sec for close dialog and reset selectColor
      clearTimeout(this.timer)
      this.timer = setTimeout(this.clearSelectColor, 30 * 1000)

      this.selectColor = color

      this.indexShowDetail = index
    },

    clearSelectColor() {
      this.selectColor = null
      if (this.dialog === true) {
        this.dialog = false
      }
    },

    isShowColorDetail(modelName) {
      if (this?.selectColor?.date) {
        return (
          this?.selectColor?.name
            ?.toLowerCase()
            .includes(modelName?.toLowerCase()) &&
          this.selectColorMessage
        )
      }

      return this?.selectColor?.name
        ?.toLowerCase()
        .includes(modelName?.toLowerCase())
    },

    isShowColorDetailNotActive(modelName) {
      if (this?.selectColor?.is_active === false) {
        return this?.selectColor?.name
          ?.toLowerCase()
          .includes(modelName?.toLowerCase())
      }

      return false
    },

    async openDialog() {
      if (!this.isVerified) {
        return
      }

      const productLink = await this.generateProductLink()

      if (productLink) {
        this.deepLink = `${window.location.origin}${productLink}`

        this.dialog = true
      }

      //  ? This Old version
      //   const slug = this.$route.params.slug

      //   let deepLink = `${window.location.origin}/${slug}/shop`

      //   let queryParams = []
      //   if (this.selectColor?.sku) {
      //     queryParams.push(`sku=${this.selectColor?.sku}`)
      //   }

      //   if (this.selectColor?.date?.condition_checkout) {
      //     let condition_checkout =
      //       this.selectColor.date.condition_checkout.toLowerCase() ===
      //       'admin'
      //     queryParams.push(`admin_quota=${condition_checkout}`)
      //   }

      //   if (this.branchId) {
      //     queryParams.push(`branch_id=${this.branchId}`)
      //   }

      //   if (this.staffCode) {
      //     queryParams.push(`sc=${this.staffCode}`)
      //   }

      //   if (this.couponCodeParam) {
      //     queryParams.push(`v=${this.couponCodeParam}`)
      //   }

      //   // TODO: Hardcoded utm params
      //   queryParams.push(`utm_source=offline_bnn-qr`)
      //   queryParams.push(`utm_medium=referral`)
      //   queryParams.push(
      //     `utm_campaign=15Sep2023-Ecom-npi-pre-order-iphone-15`,
      //   )

      //   if (queryParams.length > 0) {
      //     deepLink = `${deepLink}?${queryParams.join('&')}`
      //   }
      // }
    },

    openColor(modelName, value, model) {
      if (value && model?.sku && value?.[0]?.qr !== 'expired') {
        this.currentSelect = {
          modelName,
          campaign: value?.[0],
          model,
        }
        this.dialog = true
        if (model?.sku) {
          this.deepLink = `${window.location.origin}/${value?.[0].slug}/shop?sku=${model?.sku}`
        } else {
          this.deepLink = `${window.location.origin}/${value?.[0].slug}/shop`
        }
      }
    },

    onClickModel(model) {
      this.selectModel = model
      this.productItems = this.data?.models?.filter(
        item => item?.name === model,
      )
      this.indexShowDetail = null
      this.$forceUpdate()
    },

    onChangeBranch(branchId, branchCode) {
      this.branchId = branchId
      this.branchCode = branchCode
      this.clearVerify()
      this.$forceUpdate()
    },

    async generateProductLink() {
      const utm = {
        utm_source: this.$route.query.utm_source || null, // offline_bnn-qr
        utm_medium: this.$route.query.utm_medium || null, // referral
        utm_campaign: this.$route.query.utm_campaign || null, // 15Sep2023-Ecom-npi-pre-order-iphone-15
      }

      let payload = {
        bu: this.campaignType,
        slug: this.$route.params.slug,
        admin_quota:
          this.selectColor?.date?.condition_checkout.toLowerCase() ===
            'admin' ?? false,
        ...(this.selectColor?.sku && { sku: this.selectColor?.sku }),
        ...(this.branchId && { branch_id: this.branchId }),
        ...(this.branchCode && { branch_code: this.branchCode }),
        ...(this.staffCode && { sc: this.staffCode }),
        ...(this.couponCodeParam && { v: this.couponCodeParam }),
        ...(utm.utm_source && { utm_source: utm.utm_source }),
        ...(utm.utm_medium && { utm_medium: utm.utm_medium }),
        ...(utm.utm_campaign && { utm_campaign: utm.utm_campaign }),
      }

      const productLink = await this.$store
        .dispatch('stock/generateProductLink', payload)
        .then(response => {
          return response
        })
        .catch(error => {
          // Handle the error
          alert(
            'เกิดข้อผิดพลาดบางอย่าง กรุณาทำรายการใหม่อีกครั้ง' ||
              error?.response?.data?.message,
          )
          return null
        })

      return productLink
    },
  },
}
</script>

<style lang="stylus" scoped>
.bg-green
    background-color: $color-green-dark
    color: #fff
.bg-red
    background-color: $color-bnn-red
    color #000

table
    width 100%
    border: none !important;
    border-collapse:collapse;


tr:nth-child(odd) {
  background-color: #FAFAFA;
}

.bg-fafafa
    background-color: #FAFAFA

.border-top
    border-top 1px solid #E3E3E3


thead tr
    // position: sticky;
    top: 0;
    z-index 100


th
    padding: 1rem 1rem
    background: white;
td
    padding: 1.2rem 1rem

.status
    width: auto
    text-align: center
    display: flex
    justify-content: center
    align-items: center
    font-size: 0.7rem

.layout-matrix
    display: flex
    justify-content: center
    align-items: center
    width 100%
    height 100%

.is-desktop
    display: block
    width 100%
    @media tablet
        display: none
.is-tablet
    display: none
    @media tablet
        width 100%
        display: block

.btn-cancel
  width: 80px
  font-weight: bold !important
  font-size: 0.875rem !important
  padding: 18.5px 0 !important
  border-color: $color-secondary !important
  padding: 0 2rem

.text-cancel
  color: $color-secondary-text

.card-qrcode
  background white
  border-radius: 8px;
  border: 1px solid #00000000;
  padding: 1.5rem 1.5rem 0 1.5rem
  display: flex
  justify-content: center

.action-layout
    width: 200px
    display: flex
    justify-content: center
    padding-bottom: 0.5rem

.campaign-text
    font-size 0.875rem
    font-weight: bold
    color: $color-bnn-gray-medium-2
    line-height: 0.375rem

.color-content
  display: grid;
  gap: 16px 4px;
  grid-template-columns: repeat(6, 1fr);

.overflow
    overflow: auto

.text-span-receive
  color: #01B13D
  font-size: 0.875rem
  text-align: center
  font-weight: bold

.model-stock-container
  display: grid
  grid-template-columns: repeat(5, 1fr)
  gap: 0.75rem

  @media small
    grid-template-columns: repeat(2, 1fr)
    gap: 0.75rem 0.5rem

.model-select-color {
  margin-top: 1rem
  background: $color-bnn
  color: $color-btn-base
  border-radius: 30px
  padding:0.5rem 1rem
  font-size: 0.875rem
  width 100%
}

.model-select-color-not-active {
  margin-top: 1rem
  background: $color-bnn-red
  color: #fff
  border-radius: 30px
  padding:0.5rem 1rem
  font-size: 0.875rem
  width 100%
}
.wrap-btn-verify
  display: flex
  justify-content: flex-end
  gap: 12px
  padding-top: 12px
.btn-verify-text
  color: white !important
</style>
